var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11372_28362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8087 40.5L32.1826 13.6061H7.46091L8.83482 40.5H30.8087ZM17.3166 3.65826L8.49047 0.5L7.31656 3.65826L32.3166 12.1667L33.4905 9.00841L25.0609 6.41652L26 3.88957L18.2557 1.12957L17.3166 3.65826ZM14.0492 17.8914L11.3205 18.034L12.3205 37.0218L15.0509 36.8792L14.0492 17.8914ZM21.3813 17.9488H18.6509V36.9644H21.3813V17.9488ZM25.9831 17.8914L28.7118 18.034L27.7118 37.0218L24.9813 36.8792L25.9831 17.8914Z",
    fill: "#DA072D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11372_28362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.649902 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.717649c13ec809a0cd1b233c0b153c23.svg";
export { ForwardRef as ReactComponent };